import type { TFunction } from 'i18next'

import { PeriodicidadePagamentoEnum, type TPeriodicidadePagamentoEnum } from '@/types/simulacao'

export const constantsSimulacao = {
  LIMITE_PARCELAS_EMPREENDIMENTO_ENTREGUE: 50,
  DIVISOR_PARCELAS_INTERMEDIARIAS: 2,
  LIMITE_PARCELAS_INTERMEDIARIAS: 99,
  MES_ATUAL: 1,
  LIMITE_MINIMO_NOVA_FORMA_PAGAMENTO: 12,
  LIMITE_MAXIMO_NOVA_FORMA_PAGAMENTO: 40,
  LIMITE_MAXIMO_NOVA_FORMA_PAGAMENTO_SEM_POS_CONCLUSAO: 36,
} as const

export const getPeriodicidadeOptions = (
  t: TFunction<'simulador'>,
): Array<{ value: TPeriodicidadePagamentoEnum; label: string }> => [
  {
    value: PeriodicidadePagamentoEnum.Bimestral,
    label: t('simulador.inputs.intermediarias.periodicidade_options.bimestral'),
  },
  {
    value: PeriodicidadePagamentoEnum.Trimestral,
    label: t('simulador.inputs.intermediarias.periodicidade_options.trimestral'),
  },
  {
    value: PeriodicidadePagamentoEnum.Semestral,
    label: t('simulador.inputs.intermediarias.periodicidade_options.semestral'),
  },
  { value: PeriodicidadePagamentoEnum.Anual, label: t('simulador.inputs.intermediarias.periodicidade_options.anual') },
  {
    value: PeriodicidadePagamentoEnum.SemPeriodoFixo,
    label: t('simulador.inputs.intermediarias.periodicidade_options.sem_periodo_fixo'),
  },
]
